export const BASEAPI = import.meta.env.VITE_BASEAPI;
export const apiUrl = import.meta.env.VITE_API_URL;
export const nodeAPIUrl = import.meta.env.VITE_NODE_API_URL;
export const CARD_DETAILS_KEY = import.meta.env.VITE_CARD_DETAILS_KEY;
export const cardDetailsKey = CARD_DETAILS_KEY; // alias for backward compatibility
